import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

const classManage = () =>
  import(
    /* webpackChunkName: "public-class-manage" */ "@/views/teacherPublicNumber/classManage/index.vue"
  );
// 灰度老师管理
const classManageGray = () =>
  import(
    /* webpackChunkName: "public-class-manage-gray" */ "@/views/teacherPublicNumber/classManage/index-gray.vue"
  );
const classManageOpen = () =>
  import(
    /* webpackChunkName: "public-class-manage-open" */ "@/views/teacherPublicNumber/classManage/open.vue"
  );
const classManageClose = () =>
  import(
    /* webpackChunkName: "public-class-manage-close" */ "@/views/teacherPublicNumber/classManage/close.vue"
  );
const classManageLeave = () =>
  import(
    /* webpackChunkName: "public-class-manage-leave" */ "@/views/teacherPublicNumber/classManage/leave.vue"
  );
// 灰度请假
const classManageLeaveGray = () =>
  import(
    /* webpackChunkName: "public-class-manage-leave-gray" */ "@/views/teacherPublicNumber/classManage/leave-gray.vue"
  );
const leaveInfo = () =>
  import(
    /* webpackChunkName: "public-leave-info" */ "@/views/teacherPublicNumber/leaveInfo/index.vue"
  );
const leaveInfoGray = () =>
  import(
    /* webpackChunkName: "public-leave-info-gray" */ "@/views/teacherPublicNumber/leaveInfo-gray/index.vue"
  );
const leaveDetail = () =>
  import(
    /* webpackChunkName: "public-leave-detail" */ "@/views/teacherPublicNumber/leaveDetail/index.vue"
  );
const fixedTime = () =>
  import(
    /* webpackChunkName: "public-fixed-time" */ "@/views/teacherPublicNumber/fixedTime/index.vue"
  );
// 教管考核时段
const openAssessmentPeriod = () =>
  import(
    /* webpackChunkName: "public-open-assessment-period" */ "@/views/teacherPublicNumber/openAssessmentPeriod/index.vue"
  );
// 教管考核时段-无权限
const timeManageNoAuthorize = () =>
  import(
    /* webpackChunkName: "public-time-manage-no-authorize" */ "@/views/teacherPublicNumber/openAssessmentPeriod/noAuthorize.vue"
  );
const attendOrRefuse = () =>
  import(
    /* webpackChunkName: "public-attend-or-refuse" */ "@/views/teacherPublicNumber/attendOrRefuse/index.vue"
  );
const attendOrRefuseList = () =>
  import(
    /* webpackChunkName: "public-attend-or-refuse-list" */ "@/views/teacherPublicNumber/attendOrRefuse/list.vue"
  );
// 试听课详情
const auditionDetail = () =>
  import(
    /* webpackChunkName: "audition-info" */ "@/views/teacherPublicNumber/attendOrRefuse/auditionDetail.vue"
  );
// 试听课课件选择
const auditionSelect = () =>
  import(
    /* webpackChunkName: "audition-info" */ "@/views/teacherPublicNumber/attendOrRefuse/auditionSelect.vue"
  );
const teacherUserCenter = () =>
  import(
    /* webpackChunkName: "public-teacher-user-center" */ "@/views/teacherPublicNumber/userCenter/index.vue"
  );
/**
 * 老固定时段管理
 */
const fixedTimeIndex = () =>
  import(
    /* webpackChunkName: "public-fixed-time-index" */ "@/views/teacherPublicNumber/fixedTime/index.vue"
  );
/**
 * 固定时段管理
 */
const fixedTimeClose = () =>
  import(
    /*webpackChunkName: "teacherFixed" */ "@/views/teacherPublicNumber/fixedTime/closeTime/index.vue"
  );
/**
 * 固定时段管理
 */
const fixedTimeManageIndex = () =>
  import(
    /* webpackChunkName: "public-fixed-time-manage-index" */ "@/views/teacherPublicNumber/fixedTime/manage/index.vue"
  );
/**
 * 固定时段管理-关闭时段申请
 */
const fixedTimeManageClose = () =>
  import(
    /* webpackChunkName: "public-fixed-time-manage-close" */ "@/views/teacherPublicNumber/fixedTime/manage/close.vue"
  );
/**
 * 固定时段管理-时段变更记录列表
 */
const fixedTimeRecordList = () =>
  import(
    /* webpackChunkName: "public-fixed-time-record-list" */ "@/views/teacherPublicNumber/fixedTime/changeRecord/list.vue"
  );
/**
 * 固定时段管理-时段变更记录详情
 */
const fixedTimeRecordDetail = () =>
  import(
    /* webpackChunkName: "public-fixed-time-record-detail" */ "@/views/teacherPublicNumber/fixedTime/changeRecord/detail.vue"
  );
// 非正式老师个人中心
const userCenterNotFormal = () =>
  import(
    /* webpackChunkName: "public-user-center-not-formal" */ "@/views/teacherPublicNumber/userCenter/notFormal.vue"
  );
// 功能未开发完成的页面
const pageNotFinished = () =>
  import(
    /* webpackChunkName: "public-page-not-finished" */ "@/views/teacherPublicNumber/userCenter/noFinish.vue"
  );

export default {
  path: "/teacherPublicnumber",
  name: "teacherPublicnumber",
  component: view,
  children: [
    {
      path: "classManage",
      component: view,
      children: [
        {
          path: "",
          component: classManage
        },
        {
          path: "open",
          component: classManageOpen
        },
        {
          path: "close",
          component: classManageClose
        },
        {
          path: "leave",
          component: classManageLeave
        }
      ]
    },
    {
      path: "classManage-gray",
      component: view,
      children: [
        {
          path: "",
          component: classManageGray
        },
        {
          path: "leave",
          component: classManageLeaveGray
        }
      ]
    },
    {
      name: "leaveInfo3",
      path: "leaveInfo",
      component: leaveInfo
    },
    {
      name: "leaveInfoGray2",
      path: "leaveInfo-gray",
      meta: {
        keepAlive: true
      },
      component: leaveInfoGray
    },
    {
      name: "leaveDetail3",
      path: "leaveDetail",
      component: leaveDetail
    },
    {
      path: "fixedTime",
      component: view,
      children: [
        {
          name: "fixedTime2Def",
          path: "",
          component: fixedTimeIndex
        },
        {
          name: "closeTime3",
          path: "closeTime",
          component: fixedTimeClose
        },
        {
          name: "manage2",
          path: "manage",
          component: view,
          redirect: "manage/index",
          children: [
            {
              name: "index2",
              path: "index",
              component: fixedTimeManageIndex
            },
            {
              name: "close2",
              path: "close",
              component: fixedTimeManageClose
            }
          ]
        },
        {
          name: "record2",
          path: "record",
          component: view,
          redirect: "record/list",
          children: [
            {
              name: "list3",
              path: "list",
              meta: {
                keepAlive: true
              },
              component: fixedTimeRecordList
            },
            {
              name: "detail2",
              path: "detail",
              component: fixedTimeRecordDetail
            }
          ]
        }
      ]
    },
    {
      name: "openAssessmentPeriod2",
      path: "openAssessmentPeriod",
      component: openAssessmentPeriod
    },
    {
      name: "timeManageNoAuthorize2",
      path: "timeManageNoAuthorize",
      component: timeManageNoAuthorize
    },
    {
      name: "userCenter2",
      path: "userCenter",
      component: teacherUserCenter
    },
    {
      name: "userCenterNotFormal2",
      path: "userCenterNotFormal",
      component: userCenterNotFormal
    },
    {
      path: "attendOrRefuse",
      component: view,
      children: [
        {
          name: "attendOrRefuse2",
          path: "",
          component: attendOrRefuse
        },
        {
          name: "list4",
          path: "list",
          component: attendOrRefuseList
        },
        {
          name: "auditionDetail",
          path: "auditionDetail",
          component: auditionDetail
        },
        {
          name: "auditionSelect",
          path: "auditionSelect",
          component: auditionSelect
        }
      ]
    },
    {
      name: "pageNotFinished2",
      path: "pageNotFinished",
      component: pageNotFinished
    }
  ]
};
